import apiHandler from "../core/apiHandler";

/**
 * 🧹 API base para la limpieza de registros de caja
 * (panel solo-SUPPORT)
 *
 * Endpoint:
 * /api/cash/admin/reset
 */
const cashResetApi = apiHandler("cash/admin/reset");

export default cashResetApi;
